import { stepBaggageAndPersonalLookup as expenseLookup } from './claimCodeMapper';
function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const damagedExpenses = mapToDamagedExpenses(data);
  const aLostItemExpenses = mapToALostItemExpenses(data);
  const valuableExpenses = mapToValuableExpenses(data);
  const baggageDelayExpenses = mapToBaggageDelayExpenses(data);
  const baggageDelayPerDayExpenses = mapToBaggageDelayPerDayExpenses(data);
  return [...damagedExpenses, ...aLostItemExpenses, ...valuableExpenses, ...baggageDelayExpenses, ...baggageDelayPerDayExpenses];
}

function mapToDamagedExpenses(data) {
  if (data.areYouClaimingForDamaged !== 'true' || data.additionalItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForDamaged.claimCode;
  const expenses = [];

  data.additionalItems.forEach(
    (item) => {
      const expense = mapCollisionDamageExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }

      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToALostItemExpenses(data) {
  if (data.areYouClaimingForALostItem !== 'true' || data.expenseItemsLostItem.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForALostItem.claimCode;
  const expenses = [];

  data.expenseItemsLostItem.forEach(
    (item) => {
      const expense = mapCollisionDamageExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }

      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToValuableExpenses(data) {
  if (data.areYouClaimingForValuables !== 'true' || data.expenseItemsValuables.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForValuables.claimCode;
  const expenses = [];

  data.expenseItemsValuables.forEach(
    (item) => {
      const expense = mapCollisionDamageExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }

      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToBaggageDelayExpenses(data) {
  if (data.areYouClaimingForBaggageDelay !== 'true' || data.delayedLuggageExpenses.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForBaggageDelay.claimCode;
  const expenses = [];

  data.delayedLuggageExpenses.forEach(
    (item) => {
      const expense = mapCollisionDamageExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }

      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToBaggageDelayPerDayExpenses(data) {
  if (data.areYouClaimingForBaggageDelayPerDay !== 'true' || data.expenseItemsPerDay.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForBaggageDelayPerDay.claimCode;
  const expenses = [];

  data.expenseItemsPerDay.forEach(
    (item) => {
      const expense = mapCollisionDamageExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }

      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapCollisionDamageExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateTripInterrupted, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  if (!item || !item.estimatedValue || !item.currentEstimated) {
    return null;
  }
  return {
    shortDescription: item.itemDescription,
    dateOfExpense: item.dateOfLoss,
    clientCost: item.estimatedValue,
    currency: item.currentEstimated,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

function mapReimbursement(item, formData, claimCode) {
  if (!item || !item.howMuchReceivedReimbursement || !item.currentReceivedReimbursement || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhomReceivedReimbursement} (Reimbursement)`,
    dateOfExpense: item.dateReimbursementReceived,
    clientCost: `${item.howMuchReceivedReimbursement * -1}`,
    currency: item.currentReceivedReimbursement,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepPersonalItemDataMapper.js